module.exports = __webpack_public_path__ + "img/calendar.9f4f97c8.svg";